import { FunctionComponent, useMemo, type CSSProperties } from "react";

type FrameComponentType = {
  notificationText?: string;
  notificationDescription?: string;
  callBackMessage?: string;
};

const ClaimBox: FunctionComponent<FrameComponentType> = ({
  notificationText,
  notificationDescription,
  callBackMessage,
}) => {
  return (
    <div
      className="flex-1 w-full rounded-2xl [background:linear-gradient(180deg,_rgba(255,_255,_255,_0),_rgba(255,_255,_255,_1))] shadow-[0px_8px_0px_rgba(100,_88,_216,_0.2)] box-border flex flex-col py-10 px-6 items-center justify-start gap-[24px] min-w-[300px] text-center text-41xl text-black border-t-[1px] border-dashed"
      style={{ borderColor: "#6458D8" }}
    >
      <div className="rounded-full [background:linear-gradient(180deg,_rgba(255,_255,_255,_0),_rgba(100,_88,_216,_0.15))] w-[100px] h-[100px] flex flex-row items-center justify-start relative text-purple">
        <div
          className="absolute my-0 mx-[!important] top-[-0.04px] left-[-4px] text-6xl font-light z-[0]"
          style={{ color: "#6458D8" }}
        >
          {notificationText}
        </div>
      </div>
      <h4>{notificationDescription}</h4>
      <p>{callBackMessage}</p>
    </div>
  );
};

export default ClaimBox;
